/* eslint-disable no-underscore-dangle */
import root from 'window-or-global';
import {
  DEBUG_CONFIG_SESSION_STORAGE_KEY,
  // DEBUG_VALUE_LANGUAGE_ENGLISH,
  DEBUG_VALUE_GRID_OFF,
  DEBUG_VALUE_GRID_ON,
  DEBUG_OPTION_GRID,
  // DEBUG_OPTION_LANGUAGE,
  DEBUG_OPTION_MODE,
  // DEBUG_VALUE_LANGUAGE_POLISH,
  DEBUG_VALUE_MODE_PREVIEW,
  DEBUG_VALUE_MODE_PUBLISHED,
} from 'common/consts/debugOptionConsts';

class DebugOptionsService {
  static _subscribers = [];

  // model defines which values can be used
  static optionsModel = [
    {
      name: DEBUG_OPTION_MODE,
      values: [DEBUG_VALUE_MODE_PREVIEW, DEBUG_VALUE_MODE_PUBLISHED],
      reloadOnChange: true,
    },
    /* {
      name: DEBUG_OPTION_LANGUAGE,
      values: [DEBUG_VALUE_LANGUAGE_ENGLISH, DEBUG_VALUE_LANGUAGE_POLISH],
      reloadOnChange: true,
    }, */
    {
      name: DEBUG_OPTION_GRID,
      reloadOnChange: false,
      values: [DEBUG_VALUE_GRID_OFF, DEBUG_VALUE_GRID_ON],
    },
  ];

  static defaultDebugOptions = [
    {
      name: DEBUG_OPTION_MODE,
      value: DEBUG_VALUE_MODE_PREVIEW,
    },
    /* {
      name: DEBUG_OPTION_LANGUAGE,
      value: DEBUG_VALUE_LANGUAGE_ENGLISH,
    }, */
    {
      name: DEBUG_OPTION_GRID,
      value: DEBUG_VALUE_GRID_OFF,
    },
  ];

  static isDebug() {
    return process.env.REACT_APP_DEBUG === 'true';
  }

  static getDebugOptions() {
    try {
      const options = JSON.parse(root.sessionStorage.getItem(DEBUG_CONFIG_SESSION_STORAGE_KEY));
      if (options) {
        return options;
      }
    } catch (e) {
      return DebugOptionsService.defaultDebugOptions;
    }
    return DebugOptionsService.defaultDebugOptions;
  }

  static getDebugOptionsModel() {
    return DebugOptionsService.optionsModel;
  }

  static subscribe(observerFunction) {
    DebugOptionsService._subscribers.push(observerFunction);
  }

  static unsubscribe(observerFunction) {
    DebugOptionsService._subscribers = DebugOptionsService
      ._subscribers.filter(func => func !== observerFunction);
  }

  static _tellAboutChanges(changes) {
    DebugOptionsService._subscribers.forEach(observerFunction => observerFunction(changes));
  }

  static setDebugOptions(options) {
    root.sessionStorage.setItem(DEBUG_CONFIG_SESSION_STORAGE_KEY, JSON.stringify(options));
    DebugOptionsService._tellAboutChanges(options);
  }

  static setDebugOptionValueByName(optionName, optionValue) {
    const currentOptions = DebugOptionsService.getDebugOptions();
    if (currentOptions != null) {
      const checkedOptions = DebugOptionsService.getDebugOptions().map((currentOption) => {
        if (currentOption.name === optionName) {
          const newOption = Object.assign({}, currentOption);
          newOption.value = optionValue;
          return newOption;
        }
        return currentOption;
      });
      DebugOptionsService.setDebugOptions(checkedOptions);
    }
  }

  static getOptionValueByName(optionName) {
    const debugOptions = DebugOptionsService.getDebugOptions();
    return debugOptions ? debugOptions.find(option => option.name === optionName).value : null;
  }
}

export default DebugOptionsService;



// WEBPACK FOOTER //
// ./src/services/DebugOptions.service.js